import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDocs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={16}
    fill="none"
    viewBox="0 0 12 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.75 8.417h4.5a.645.645 0 0 0 .475-.192.645.645 0 0 0 .192-.475.645.645 0 0 0-.192-.475.645.645 0 0 0-.475-.192h-4.5a.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475c0 .189.064.347.192.475a.645.645 0 0 0 .475.192m0 2.5h4.5a.645.645 0 0 0 .475-.192.645.645 0 0 0 .192-.475.645.645 0 0 0-.192-.475.645.645 0 0 0-.475-.192h-4.5a.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475c0 .189.064.347.192.475a.645.645 0 0 0 .475.192m0 2.5h2.292a.645.645 0 0 0 .475-.192.645.645 0 0 0 .191-.475.645.645 0 0 0-.191-.475.645.645 0 0 0-.475-.192H3.75a.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475c0 .189.064.347.192.475a.645.645 0 0 0 .475.192M1.494 16c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 0 1 0 14.5v-13C0 1.087.147.734.44.44.735.148 1.088 0 1.5 0h5.875a1.44 1.44 0 0 1 1.063.438l3.124 3.125A1.44 1.44 0 0 1 12 4.625V14.5c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44zM10.5 5H8.125c-.312 0-.578-.11-.797-.328A1.085 1.085 0 0 1 7 3.875V1.5H1.5v13h9z"
    />
  </svg>
);
export default SvgDocs;
